module.exports = __webpack_public_path__ + "img/Reviews.72b59708.webp";